const clampOpacity = (value: number) => Math.min(1, Math.max(0, value));

export const fade = (color: string, opacity: number) => {
  const resolvedOpacity = clampOpacity(opacity);
  if (resolvedOpacity <= 0) {
    return 'transparent';
  }
  if (resolvedOpacity >= 1) {
    return color;
  }
  return `color-mix(in srgb, ${color} ${resolvedOpacity * 100}%, transparent)`;
};
